/*
App main file
*/
// import styles
import '../css/style.less';
import 'bootstrap';
// import custom scripts
import './scripts/reactSPA';
import './scripts/footer-functions';
//import './scripts/skillSet';
import './scripts/toTop';
// import backbone/react
import Router from './router/main';
import ReactGA from 'react-ga';
import {HomeController, CvController, MapController} from './controller/index.js';
import MainView from './view';


class Application {
  constructor() {
    //additional initialization
    this.initialize();

    // Add your tracking ID created from https://analytics.google.com/analytics/web/#home/
  	ReactGA.initialize('UA-116312395-2');
  	// This just needs to be called once since we have no routes in this case.
  	ReactGA.pageview(window.location.hash);
  }



  initialize() {
    let self = this;
    this._mainView = new MainView();

    // this._pageController = new PageController({
    //   app: self
    // });

    this._homeController = new HomeController({
      app: self
    });

    this._cvController = new CvController({
      app: self
    });

    this._mapController = new MapController({
      app: self
    });

    this._router = new Router({
      controllers: {
        // page: self._pageController,
        home: self._homeController,
        cv: self._cvController,
        map: self._mapController
      }
    });
    //start backbone history
    Backbone.history.start();
    console.log('app finished initializing!');
  }

  get router() {
    return this._router;
  }
}


//start up function
$(() => {
  //webpack works
  console.log('Loading...');

  let app = new Application();
  // console.log(app);
});



// WEBPACK FOOTER //
// src/js/index.js